import { useState, useEffect } from 'react';
import { Button, LoaderType, NextgenImage, useNextgenRouter, useTranslation } from '@nextgen-web-framework/all';
import { cmsApi } from '@commerce-webcomponents/sdk';
import {
  adminNoSearchRulesImage,
  myListCmsDataTransformer,
  type Images,
  type cartCmsDataType,
  CartRoutePaths,
} from '@commerce-cart-webcomponents/sdk';
import styles from './EmptyList.module.scss';
import { EmptyListPropTypes } from './types/propTypes';

export const EmptyList = ({ isWishlist = false, listRemoved = false, isListFilter = false }: EmptyListPropTypes) => {
  const t = useTranslation();
  const [image, setImage] = useState<Images>();
  const router = useNextgenRouter();
  const fetchCMSImage = async () => {
    const data = await cmsApi.fetchContent({
      uId: 'cart',
    });
    setImage(
      isListFilter
        ? adminNoSearchRulesImage(data as cartCmsDataType)
        : myListCmsDataTransformer(data as cartCmsDataType),
    );
  };

  const showEmptyPages = () => {
    if (listRemoved) {
      return (
        <div className={styles['empty-list']}>
          <div className={styles['image-wrapper']}>
            <NextgenImage
              loaderType={LoaderType.CONTENTSTACK}
              src={image?.image.url || ''}
              alt={image?.alt_text || ''}
            />
          </div>
          <div className={styles['empty-list-text']}>
            <h3>{t('cart.myList.listRemoved')}</h3>
            <p>{t('cart.myList.listRemovedDescription')}</p>
          </div>
          <Button
            data-testid="start-shopping"
            title={t('cart.myList.startShopping')}
            onClick={() => router.push(CartRoutePaths.HOME)}
          />
        </div>
      );
    }
    return (
      <div className={`${styles['empty-list']} ${isListFilter ? styles['list-filter'] : ''}`}>
        <div className={styles['image-wrapper']}>
          <NextgenImage loaderType={LoaderType.CONTENTSTACK} src={image?.image.url || ''} alt={image?.alt_text || ''} />
        </div>
        <div className={styles['empty-list-text']}>
          <h3>
            {isListFilter
              ? t('cart.list.listFilters.notFound')
              : isWishlist
                ? t('cart.myList.wishlistEmpty')
                : t('cart.myList.listIsEmpty')}
          </h3>
          <p>
            {isListFilter
              ? t('cart.list.listFilters.pleaseTryDifferentFilter')
              : isWishlist
                ? t('cart.myList.wishlistExplore')
                : t('cart.myList.addProducts')}
          </p>
        </div>
        {isWishlist && (
          <Button title={t('cart.emptyCart.cartEmptyBtnLabel')} onClick={() => router.push(CartRoutePaths.HOME)} />
        )}
      </div>
    );
  };

  useEffect(() => {
    fetchCMSImage();
  }, []);
  return <>{showEmptyPages()}</>;
};
